import { apiClient } from "../config";
async function getAllProfileReports(queryParams: any, id: any) {
  const res = await apiClient.get(`/admin/reports/${id}`, {
    params: queryParams,
  });
  return res.data;
}
export default getAllProfileReports;
